/* ======================================================================
   AMORE COLLECTIVE — OPEN THE DESKTOP MEGA MENU ON HOVER  (added 31 Jul 2026)
   ----------------------------------------------------------------------
   Dawn opens each top-level menu dropdown on CLICK. This opens/closes it on
   HOVER instead by toggling the native <details open> state as the pointer
   enters/leaves each menu item — so Dawn's own show/close animation and
   outside-click handling keep working. Clicking a link still navigates.

   Because the header bar is tall, there is a gap between a menu link and its
   dropdown panel. Closing is therefore DELAYED (CLOSE_DELAY ms): moving the
   pointer across that gap into the panel cancels the pending close, so the
   menu no longer disappears when you go to click a link. Increase CLOSE_DELAY
   if the gap ever feels too "twitchy".

   While ANY dropdown is open we also add a `.amore-menu-open` class to <body>.
   On the homepage the header sits transparently over the hero image; that class
   is what turns the whole top area (announcement bar + header row) solid white
   with dark text — matching the white dropdown, Meshki-style — via rules in
   assets/amore-hero-header.css. The class is kept in sync with a native
   `toggle` listener on each <details>, so it stays correct no matter what opens
   or closes the menu (hover, click, or the sticky header auto-closing it).

   Desktop only (>=990px); on mobile the header uses the hamburger drawer, so
   this does nothing there. Loaded site-wide via snippets/meta-tags.liquid.
   To revert: remove this file's <script> line from meta-tags.liquid.
   ====================================================================== */
(function () {
  var mq = window.matchMedia('(min-width: 990px)');
  var CLOSE_DELAY = 280; // ms grace period to cross the gap to the dropdown

  // Add/remove <body>.amore-menu-open depending on whether any dropdown is open.
  function syncOpenState() {
    var anyOpen = document.querySelector('.header__inline-menu header-menu details[open]');
    document.body.classList.toggle('amore-menu-open', !!anyOpen);
  }

  function bind() {
    var menus = document.querySelectorAll('.header__inline-menu header-menu');
    menus.forEach(function (menu) {
      if (menu.dataset.amoreHover) return;
      var details = menu.querySelector('details');
      if (!details) return;
      menu.dataset.amoreHover = '1';
      var summary = menu.querySelector('summary');
      var closeTimer = null;

      // Keep the <body> white-header class in sync with this dropdown's state.
      details.addEventListener('toggle', syncOpenState);

      function openMenu() {
        if (!mq.matches) return;
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }

      function scheduleClose() {
        if (!mq.matches) return;
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
          closeTimer = null;
        }, CLOSE_DELAY);
      }

      // mouseenter fires when the pointer (re-)enters the menu OR its dropdown
      // panel (a descendant), which cancels any pending close.
      menu.addEventListener('mouseenter', openMenu);
      menu.addEventListener('mouseleave', scheduleClose);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
